export const enum reviewConstants {
  // List reviews
  listReviewsRequest = "LIST_REVIEWS_REQUEST",
  listReviewsSuccess = "LIST_REVIEWS_SUCCESS",
  listReviewsFailure = "LIST_REVIEWS_FAILURE",

  // Get instructor ratings
  getInstructorRatingsRequest = "GET_INSTRUCTOR_RATINGS_REQUEST",
  getInstructorRatingsSuccess = "GET_INSTRUCTOR_RATINGS_SUCCESS",
  getInstructorRatingsFailure = "GET_INSTRUCTOR_RATINGS_FAILURE",

  // Get school ratings
  getSchoolRatingsRequest = "GET_SCHOOL_RATINGS_REQUEST",
  getSchoolRatingsSuccess = "GET_SCHOOL_RATINGS_SUCCESS",
  getSchoolRatingsFailure = "GET_SCHOOL_RATINGS_FAILURE",

  // Delete review
  deleteReviewRequest = "DELETE_REVIEW_REQUEST",
  deleteReviewSuccess = "DELETE_REVIEW_SUCCESS",
  deleteReviewFailure = "DELETE_REVIEW_FAILURE",

  // View review
  viewReviewRequest = "VIEW_REVIEW_REQUEST",
  viewReviewSuccess = "VIEW_REVIEW_SUCCESS",
  viewReviewFailure = "VIEW_REVIEW_FAILURE",

  getSchoolByRatingsRequest = "GET_SCHOOL_BY_RATINGS_REQUEST",
  getSchoolByRatingsSuccess = "GET_SCHOOL_BY_RATINGS_SUCCESS",
  getSchoolByRatingsFailure = "GET_SCHOOL_BY_RATINGS_FAILURE",

};
